// src/hooks/use-toast.ts
import { useState, useCallback } from "react"

export interface Toast {
  id: number
  title: string
  description?: string
  variant?: "default" | "destructive"
}

export function useToast() {
  const [toasts, setToasts] = useState<Toast[]>([])
  const toast = useCallback((opts: Omit<Toast, "id">) => {
    const id = Date.now()
    setToasts((prev) => [...prev, { id, ...opts }])
    setTimeout(() => setToasts((prev) => prev.filter(t => t.id !== id)), 5000)
  }, [])
  return { toasts, toast }
}
